// ATCD Adulte
import ATCDAdultePersonnel from '@/views/consultations/en-cours/antecedent-adulte-personnel'
import ATCDAdulteFamiliaux from '@/views/consultations/en-cours/antecedent-adulte-familiaux'
import dmpApi from '@/api/_consultation-dmp'

export default {
    name: 'recap-dmp',
    components: {
        ATCDAdultePersonnel, ATCDAdulteFamiliaux
    },
    props: {
        type_consultation_id: Number
    },
    data() {
        return {
            global_dmp_loading: true,
            global_dmp_error: false,
            all_patient_dmp: [],
            request_sequence: 0,
            type_dmp_loading: true,
            type_dmp_is_empty: false,
            can_see_atcd: false,
            is_old_atcd: true,
        }
    },
    watch: {
        type_consultation_id() { this.refreshConsultationTypeDmp() },
        '$route.params.id'() { this.refreshConsultationTypeDmp() }
    },
    mounted() {
        this.refreshConsultationTypeDmp()
    },
    methods: {
        async refreshConsultationTypeDmp() {
            const sequence = ++this.request_sequence
            this.all_patient_dmp = []
            this.global_dmp_loading = true
            this.global_dmp_error = false
            const data = {
                type_consultation_id: this.type_consultation_id,
                patient_id: this.$route.params.id
            }
            try {
                const response = await dmpApi.getAllPatientDmp(data)
                if (sequence !== this.request_sequence) return
                if (!Array.isArray(response)) throw new Error('Réponse des antécédents invalide')
                this.all_patient_dmp = response
            } catch (error) {
                if (sequence === this.request_sequence) this.global_dmp_error = true
            } finally {
                if (sequence === this.request_sequence) this.global_dmp_loading = false
            }
        },

        editer(dmp) {
            const type_dmp = dmp.type_dmp
            this.$emit('changeView', { info_dmp: dmp, type_dmp: type_dmp, is_edit: true })
        }
    }
}
